import CardCommon from '@op/components/CardCommon';
import React from 'react';
import RisingKeywords from './RisingKeywords';
import RisingTopics from './RisingTopics';
import { formatTimeToShow } from '@op/utils/time';
import './index.scss';
import { useIntl } from 'umi';
import { useToOpinionPage } from '../utils';
import SvgIcon from '@home/components/SvgIcon';

export default function NoticeableOpinions({
  filter,
  gameInfo,
  translateTopic,
  timeValue,
}: any) {
  const { formatMessage } = useIntl();
  const { goToOtherPage } = useToOpinionPage({
    filter,
    key: 'Opinion Highlights',
  });

  const shouldPassFilter = timeValue && Object.keys(timeValue).length > 0;

  return (
    <CardCommon
      title={
        <div className="dbh-opinions-highlight-title-wrapper">
          <span className="dbh-opinions-highlight-title">
            {formatMessage({ id: 'dbh_studio_report_opinion_highlight' })}
          </span>
          {
            gameInfo?.studioid !== 'techland' && <SvgIcon
              type="studio-arrow"
              className="dbh-opinions-highlight-title-icon"
            />
          }
        </div>
      }
      subTitle={formatTimeToShow(filter)}
      className="dbh-studio-noticeable-opinion"
      onClick={() => {
        // 仅针对Techland专区下的所有游戏，关闭舆情页中，【热门视频&帖子】与【舆情动态】的跳转
        if (gameInfo?.studioid === 'techland') return;
        goToOtherPage({});
      }}
    >
      <RisingTopics
        translateTopic={translateTopic}
        filter={shouldPassFilter ? filter : {}}
        gameInfo={gameInfo}
      />
      <RisingKeywords filter={shouldPassFilter ? filter : {}} gameInfo={gameInfo} />
    </CardCommon>
  );
}
